import { Stack } from '@mui/material';
import BaseInputLabel from '../../../../components/custom-inputs/BaseInputLabel';
import CustomChip from '../../../../components/custom-chip/CustomChip';

interface ChipGroupProps {
  label: string;
  choices: Map<string, string>;
  values: any;
  translation?: {
    t: (key: string, options?: Record<string, unknown>) => string;
    ns?: string;
  };
}

const ChipGroup = ({ label, choices, values, translation }: ChipGroupProps) => {
  const getTranslatedChoiceLabel = (value: string) =>
    translation ? translation.t(value, translation.ns ? { ns: translation.ns } : undefined) : value;

  return (
    <Stack flex={1}>
      <BaseInputLabel text={label} />
      <Stack direction="row" gap={1} flexWrap="wrap">
        {values?.map((item: any) => (
          <CustomChip label={getTranslatedChoiceLabel(choices.get(item) ?? '')} />
        ))}
      </Stack>
    </Stack>
  );
};

export default ChipGroup;
